import React from 'react'

import { Flex, Heading, Image, Text } from 'stardust'

import empty from '~/assets/images/empty.svg'
import { SPACERS } from '~/theme'

interface Props {
  heading: string
  message?: string
  image?: string
}

const Empty = ({ heading, message, image }: Props) => (
  <Flex
    alignItems="center"
    flexDirection="column"
    justifyContent="center"
    py={4}
    textAlign="center"
    width="100%"
    mx="auto"
    mt={SPACERS.md}>
    <Image alt="" src={image || empty} width="10rem" height="auto" />
    <Heading.h3 caps mb={3}>
      No {heading}
    </Heading.h3>
    {message && (
      <Text.p mb={4} maxWidth="34rem">
        {message}
      </Text.p>
    )}
  </Flex>
)

Empty.displayName = 'Empty'

export default React.memo(Empty)
